import React, { useState } from "react";
import styled from "styled-components";
import BotoneraModern from "../../components/Botonera/BotoneraModern.tsx";
import QuotationList from "../../components/MarketPlace/Cotizaciones/QuotationList";
import { connect } from "react-redux";
import useNavVisibility from "../../hooks/useNavVisibility.ts";
import { getAllMaterialsCatalogFile } from "../../store/actions";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  padding-right: 2%;
  padding-left: 2%;
  max-width: 150rem;
        margin: auto;

  @media (max-width: 1200px) {
    padding-right: 2%;
    padding-left: 2%;
    }

  @media (max-width: 768px) {
    padding-right: 0;
    padding-left: 0;
  }
  `;

const Wrapper = styled.div`
  width: 100%;

  `
  ;

const CotizacionDeMateriales = ({
  userData,
  totalPrivateQuotations,
  initialType = "Publicas" }) => {
  const { ocultarEnMobile, mobileStylesFromParent } = useNavVisibility();
  const [selectedOption, setSelectedOption] = useState(initialType);

  return (
    <Container>
      {ocultarEnMobile && <BotoneraModern mobileStylesFromParent={mobileStylesFromParent} />}
      <Wrapper>
          <QuotationList setSelectedOption={setSelectedOption} selectedOption={selectedOption} />
      </Wrapper>
    </Container >
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.general.userData,
    totalPrivateQuotations: state.dashboard.totalPrivateQuotations,
  };
}

export default connect(mapStateToProps, {
  getAllMaterialsCatalogFile
})(CotizacionDeMateriales);
